import { LmgService } from "../resource";

const PaymentModule = {
  namespaced: true,
  state: {
    datas: [],
    clear_datas: [],
    branch_datas: [],
    branch_cash: [],
    data: {},
    cash_clear: [
        { ID: 1, Name: "ไม่มีเงินสดค้างที่พนักงาน" },
        { ID: 2, Name: "มีเงินสดคงค้างที่พนักงาน" },
        { ID: 3, Name: "ไม่ใช้เงินสด ไม่มีเงินค้าง" }
    ],
    payment_method: [
      { ID: 1, Name: "เงินสด" },
      { ID: 2, Name: "เช็ค" },
      { ID: 3, Name: "โอนเงิน" },
      { ID: 4, Name: "เงินสำรองจ่าย" }
    ],
  },
  mutations: {
    SET_DATAS(state, data) {
      state.datas = data;
    },
    SET_CLEAR(state, data) {
      state.clear_datas = data;
    },
    SET_BRANCH(state, data) {
      state.branch_datas = data;
    },
    SET_BRANCH_CASH(state, data) {
      state.branch_cash = data;
    },
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    getPaymentImage({ commit, state }, payload){
      return LmgService.PaymentImage(payload)
    },
    async getPaymentImage2({ commit, state }, payload){
      const res = await LmgService.PaymentImage(payload);
        const buffer = Buffer.from(res.data).toString('base64');
       return  "data:" + res.headers["content-type"] + ";base64,"+buffer

    },
    createData({ commit, state }, payload) {
      return LmgService.PaymentCreate(payload);
    },
    async listData({ commit, state }, payload) {
      try {
        const data = await LmgService.PaymentList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },
    createClear({ commit, state }, payload) {
      return LmgService.PaymentClearCreate(payload);
    },

    async listClear({ commit, state }, payload) {
      try {
        const data = await LmgService.PaymentClearList(payload);
        if (data.data.Data == null) {
          commit("SET_CLEAR", []);
        } else {
          commit("SET_CLEAR", data.data.Data);
        }
      } catch (err) {
        commit("SET_CLEAR", []);
      }
    },
    createBranchTransfer({ commit, state }, payload) {
      return LmgService.PaymentBranchTransferCreate(payload);
    },
    async listBranchTransfer({ commit, state }, payload) {
      try {
        const data = await LmgService.PaymentBranchTransferList(payload);
        if (data.data.Data == null) {
          commit("SET_BRANCH", []);
        } else {
          commit("SET_BRANCH", data.data.Data);
        }
      } catch (err) {
        commit("SET_BRANCH", []);
      }
    },
    async listBranchCash({ commit, state }, payload) {
      try {
        const data = await LmgService.PaymentBranchCash(payload);
        if (data.data.Data == null) {
          commit("SET_BRANCH_CASH", []);
        } else {
          commit("SET_BRANCH_CASH", data.data.Data[0]);
        }
      } catch (err) {
        console.log(err)
        commit("SET_BRANCH_CASH", []);
      }
    },

    
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getClear(state) {
      return state.clear_datas;
    },
    getBranchCash(state) {
      return state.branch_cash;
    },
    getBranch(state) {
      return state.branch_datas;
    },
    getCashClearTableWithAll(state){
      return [{ID:0, Name : "ทั้งหมด"},...state.cash_clear];
    },
    getCashClearName( state ){
      var self = this;
      return function (id){
        let s =  state.cash_clear.filter(f => {
          return f.ID == id;
        });
        return s.length == 0 ? 'Unknown' : s[0].Name
      }
    },
    getPaymentMethodTable(state){
      return state.payment_method;
    },
    getPaymentMethodTableWithAll(state){
      return [{ID:0, Name : "ทั้งหมด"},...state.payment_method];
    },
    getPaymentMethodName( state ){
      var self = this;
      return function (id){
        let s =  state.payment_method.filter(f => {
          return f.ID == id;
        });
        return s.length == 0 ? 'Unknown' : s[0].Name
      }
    },
    getPaymentImageURL(state){
      var self = this;
      return function (id){
        return process.env.VUE_APP_API_BASE_URL + "/api/payment/tfimage?id=" + id
      }

    }
  }
};

export default PaymentModule;
